export const localStorageOpts = "sv_pageOptions"
